import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DashboardListCard from 'modules/common/dashboard/DashboardListCard';
import DashboardChartMapContainer from './containers/CivilRegistryDashboardContainer';
import * as actions from './action';
import * as c from './constant';

const getList = (data) => [
  {
    label: 'Issued',
    value: _.get(data, 'ISSUED', 0),
    borderClassName: 'paid',
  },
  {
    label: 'For Pickup',
    value: _.get(data, 'FOR PICK-UP', 0),
    borderClassName: 'pickup',
  },
  {
    label: 'For Printing',
    value: _.get(data, 'FOR PRINTING', 0),
    borderClassName: 'paid',
  },
  {
    label: 'Waiting for Payment',
    value: _.get(data, 'WAITING FOR PAYMENT', 0),
    borderClassName: 'waiting',
  },
  {
    label: 'For Payment Confirmation',
    value: _.get(data, 'FOR PAYMENT CONFIRMATION', 0),
    borderClassName: 'paid',
  },
  {
    label: 'For Payment',
    value: _.get(data, 'PENDING', 0),
    borderClassName: 'checking',
  },
  {
    label: 'For Appearance',
    value: _.get(data, 'FOR APPEARANCE', 0),
    borderClassName: 'appearance',
  },
  {
    label: 'For Evaluation',
    value: _.get(data, 'FOR CHECKING', 0),
    borderClassName: 'rejected',
  },
  {
    label: 'For Resubmission',
    value: _.get(data, 'FOR RESUBMISSION', 0),
    borderClassName: 'pickup',
  },
  {
    label: 'Expired Reference Number',
    value: _.get(data, 'EXPIRED REFERENCE NUMBER', 0),
    borderClassName: 'received',
  },
  {
    label: 'Cancelled',
    value: _.get(data, 'CANCELLED', 0),
    borderClassName: 'received',
  },
];

function TransactionsContainer({ totalStats, getTotalStats }) {
  const permissions = getJson('permissions');

  const returnTransactionData = () => {
    const data = _.get(totalStats, 'item.total_birth_certificate_per_status');
    return {
      label: 'Birth Certificate',
      total: _.get(totalStats, 'item.total_birth_certificate', 0),
      // photo: ''
      list: getList(data),
    };
  };

  const returnTransactionDeath = () => {
    const data = _.get(totalStats, 'item.total_death_certificate_per_status');
    return {
      label: 'Death Certificate',
      total: _.get(totalStats, 'item.total_death_certificate', 0),
      // photo: ''
      list: getList(data),
    };
  };

  const returnTransactionMarriage = () => {
    const data = _.get(
      totalStats,
      'item.total_marriage_certificate_per_status'
    );
    return {
      label: 'Marriage Certificate',
      total: _.get(totalStats, 'item.total_marriage_certificate', 0),
      // photo: ''
      list: getList(data),
    };
  };

  useEffect(() => {
    getTotalStats();
  }, []);
  return (
    <div className="container-fluid mb-3">
      <div className="row">
        <div className="col-4 pl-0">
          {Acl(permissions, ['VIEW BIRTH CERTIFICATE']) && (
            <DashboardListCard
              data={returnTransactionData()}
              className="mb-3"
            />
          )}
          {Acl(permissions, ['VIEW DEATH CERTIFICATE']) && (
            <DashboardListCard
              data={returnTransactionDeath()}
              className="mb-3"
            />
          )}
          {Acl(permissions, ['VIEW MARRIAGE CERTIFICATE']) && (
            <DashboardListCard
              data={returnTransactionMarriage()}
              className="mb-3"
            />
          )}
        </div>
        <div className="col-8 pr-0">
          <DashboardChartMapContainer />
        </div>
      </div>
    </div>
  );
}

TransactionsContainer.propTypes = {
  totalStats: PropTypes.instanceOf(Object).isRequired,
  getTotalStats: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  totalStats: _.get(api, `${c.GET_TOTAL_STATS}`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(TransactionsContainer);
